import { getOptionNameByCode, OptionItem } from '@/model/OptionItem';

export enum AuthStatusEnum {
  INIT = 1,
  PROGRESS = 2,
  FAIL = 3,
  SUCCESS = 4,
  OVER_DUE = 5,
}

export const AuthStatusDict: OptionItem[] = [
  {
    code: AuthStatusEnum.INIT,
    name: '去认证',
  },
  {
    code: AuthStatusEnum.PROGRESS,
    name: '认证中',
  },
  {
    code: AuthStatusEnum.SUCCESS,
    name: '已完成',
  },
  {
    code: AuthStatusEnum.FAIL,
    name: '认证有误',
  },
  {
    code: AuthStatusEnum.OVER_DUE,
    name: '认证过期',
  },
];

export enum AuthTypeEnum {
  /** 个税信息 */
  INCOME_TAX = 'INCOME_TAX',
  /** 公积金信息 */
  HOUSE_FUND = 'HOUSE_FUND',
  /** 支付宝账单  */
  ALI_PAY_INFO = 'ALI_PAY_INFO',
}

export const AuthStatusValue = (
  val: AuthStatusEnum,
): string => getOptionNameByCode(val, AuthStatusDict);
